<script lang="ts">
    import type { IconGraphicProps } from '../../foundations/iconography.js'

    let { class: className, ...svgAttributes }: IconGraphicProps = $props()
</script>

<svg
    {...svgAttributes}
    class={className}
    fill="none"
    viewBox="0 0 16.0359 9.97874"
    xmlns="http://www.w3.org/2000/svg"
>
<path id="Vector" d="M7.99048 9.97874C7.52381 9.97874 7.12381 9.77874 6.85714 9.44541L0.257143 2.04541C-0.142857 1.51207 -0.0761905 0.712075 0.457143 0.312075C0.990476 -0.0879249 1.72381 -0.087925 2.12381 0.445408L7.85714 6.97874C7.92381 7.04541 7.99048 7.04541 8.12381 6.97874L13.8571 0.445408C14.3238 -0.087925 15.0571 -0.154592 15.5905 0.312075C16.1238 0.778742 16.1905 1.51207 15.7238 2.04541C15.7238 2.04541 15.7238 2.04541 15.6571 2.11207L9.12381 9.51207C8.85714 9.77874 8.39048 9.97874 7.99048 9.97874Z" fill="var(--fill-0, #393939)"/>
</svg>
